export class TrainingClassTrainerSurveyURL {

    ID: number;
    Created: Date;
    Modified: Date;
    TrainerID: number;
    SurveyURL: string;
    EmbeddedSurveyHTML: string;

    public static FixDates(item: TrainingClassTrainerSurveyURL) {
        item.Created = new Date(item.Created);
        item.Modified = new Date(item.Modified);
    }

}

export class TrainingClassTrainerSurveyURLArray extends Array<TrainingClassTrainerSurveyURL> {

    constructor(...items: TrainingClassTrainerSurveyURL[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingClassTrainerSurveyURLArray.prototype);
    }

    public static FixDates(item: TrainingClassTrainerSurveyURLArray) {
        item.forEach(x => TrainingClassTrainerSurveyURL.FixDates(x));
    }

}
